/**
 * Read homeowner_code from a URL, then return the same URL without it.
 * The page calls history.replaceState with href after it has copied code.
 */

function stripHomeownerCode(href) {
  const input = String(href || '');
  const hashIndex = input.indexOf('#');
  const beforeHash = hashIndex === -1 ? input : input.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : input.slice(hashIndex);
  const queryIndex = beforeHash.indexOf('?');
  if (queryIndex === -1) return { code: '', href: input };
  const path = beforeHash.slice(0, queryIndex);
  const params = new URLSearchParams(beforeHash.slice(queryIndex + 1));
  if (!params.has('homeowner_code')) return { code: '', href: input };
  const code = params.get('homeowner_code') || '';
  params.delete('homeowner_code');
  const query = params.toString();
  return { code, href: `${path}${query ? `?${query}` : ''}${hash}` };
}

export { stripHomeownerCode };
